const MEXICO_TZ = "America/Mexico_City";

export function formatDateTimeMx(value) {
    if (!value) return "—";
    return new Date(value).toLocaleString("es-MX", { timeZone: MEXICO_TZ });
}

export function formatTimeMx(value) {
    if (!value) return "—";
    return new Date(value).toLocaleTimeString("es-MX", { timeZone: MEXICO_TZ });
}
